import { Box, Card, CardContent, Link, Stack, Typography } from "@mui/material";
import TEST_ID from "enums/TEST_ID";
import {
  APP_STORE_URL,
  GOOGLE_PLAY_URL,
} from "features/ParticipantManagement/ViewInvite/defaultInviteEmail";
import { getDataTestProp } from "utils/cypressTesting";

export default function DownloadAppPage() {
  return (
    <Card
      sx={{ maxWidth: 560, width: "100%" }}
      {...getDataTestProp(TEST_ID.participantSignup.downloadApp)}
    >
      <CardContent>
        <Typography variant="h5" gutterBottom>
          You are signed up
        </Typography>
        <Typography color="text.secondary" paragraph>
          Thank you for confirming your email. Install Vidlet 3.0 on your phone,
          then sign in with the email address you used and the PIN from your
          invitation email.
        </Typography>
        <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
          Download the app
        </Typography>
        <Stack spacing={1}>
          <Link
            {...getDataTestProp(TEST_ID.participantSignup.appStoreLink)}
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Apple App Store
          </Link>
          <Link
            {...getDataTestProp(TEST_ID.participantSignup.playStoreLink)}
            href={GOOGLE_PLAY_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Google Play Store
          </Link>
        </Stack>
        <Box sx={{ mt: 3 }}>
          <Typography variant="subtitle2" color="text.secondary">
            Next steps
          </Typography>
          <Typography component="ol" sx={{ pl: 2, mt: 1 }}>
            <li>Install Vidlet 3.0 from your app store.</li>
            <li>Open the app and sign in with your email and PIN.</li>
            <li>Complete the study script shown in the app.</li>
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
